import React from "react";
import { ItemDetailsData } from "../../../../Utils/DefinitionsInterfaces";
import usePricing from "../../../../Utils/hooks/usePricing";
import PricingService from "../../../../Utils/PricingService";

interface ItemSummaryProps {
  items: ItemDetailsData[];
  selectedOption: "prepaid" | "cod";
}

const ItemSummary: React.FC<ItemSummaryProps> = ({ items, selectedOption }) => {
  const { cartPricing, calculateCODCharges, calculateOrderTotal, formatPrice } =
    usePricing(selectedOption);

  // Use the cart pricing from the service which includes all discounts
  const totalBasePrice = cartPricing.subtotal.basePrice;
  const totalSellingPrice = cartPricing.subtotal.sellingPrice;
  const totalDiscount = totalBasePrice - totalSellingPrice;
  const prepaidDiscount = cartPricing.subtotal.prepaidDiscount;
  const couponDiscount = cartPricing.subtotal.couponDiscount; // Use from subtotal instead of couponData
  const codCharges = selectedOption === "cod" ? calculateCODCharges() : 0;
  const orderTotal = calculateOrderTotal(selectedOption);

  return (
    <div style={{ marginBottom: "20px", color: "#FFF" }}>
      <div style={{ fontSize: "16px" }}>
        <strong>Items:</strong>
        <ul style={{ padding: "0px 20px" }}>
          {items.map((item) => (
            <li key={item.id}>{item.name}</li>
          ))}
        </ul>
      </div>
      <br />
      <div
        style={{
          fontSize: "16px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <strong>Subtotal: </strong>
        <div
          style={{
            width: "60%",
            height: "1px",
            backgroundColor: "#FFF",
          }}
        ></div>
        <div
          style={{
            marginLeft: "5px",
          }}
        >
          {formatPrice(totalBasePrice)}
        </div>
      </div>
      <br />
      <div
        style={{
          fontSize: "16px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <strong>Discount: </strong>
        <div
          style={{
            width: "60%",
            height: "1px",
            backgroundColor: "#FFF",
          }}
        ></div>
        <div
          style={{
            marginLeft: "5px",
          }}
        >
          {formatPrice(totalDiscount)}
        </div>
      </div>
      {selectedOption === "prepaid" && prepaidDiscount > 0 && (
        <div>
          <br />
          <div
            style={{
              fontSize: "16px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <strong>Prepaid Discount (5%): </strong>
            <div
              style={{
                width: "40%",
                height: "1px",
                backgroundColor: "#FFF",
              }}
            ></div>
            <div
              style={{
                marginLeft: "5px",
              }}
            >
              -{formatPrice(prepaidDiscount)}
            </div>
          </div>
        </div>
      )}
      {cartPricing.couponData.isApplied && (
        <div>
          <br />
          <div
            style={{
              fontSize: "16px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <strong>Coupon Discount ({cartPricing.couponData.code}): </strong>
            <div
              style={{
                width: "40%",
                height: "1px",
                backgroundColor: "#FFF",
              }}
            ></div>
            <div
              style={{
                marginLeft: "5px",
              }}
            >
              -{formatPrice(couponDiscount)}
            </div>
          </div>
        </div>
      )}
      {selectedOption === "cod" && (
        <div>
          <br />
          <div
            style={{
              fontSize: "16px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <strong>COD Charges: </strong>
            <div
              style={{
                marginLeft: "5px",
                height: "1px",
                backgroundColor: "#FFF",
                width: "45%",
              }}
            ></div>
            <div
              style={{
                marginLeft: "5px",
              }}
            >
              {formatPrice(codCharges)}
            </div>
          </div>
        </div>
      )}
      <br />
      <div
        style={{
          fontSize: "16px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <strong>Order Total: </strong>
        <div
          style={{
            marginLeft: "5px",
            height: "1px",
            backgroundColor: "#FFF",
            width: "55%",
          }}
        ></div>
        <div
          style={{
            marginLeft: "5px",
          }}
        >
          {formatPrice(orderTotal)}
        </div>
      </div>
      <br />
    </div>
  );
};

export default ItemSummary;
